import React, {Component, Fragment} from "react";
//import logo from "./logo.svg";
import "./App.css";
import "antd/dist/antd.css";
import {BrowserRouter as Router} from "react-router-dom";
import {CssBaseline} from "@material-ui/core";
import {Header, Footer} from "./Components/Layouts";
import LandingContainer from "./redux/containers/LandingContainer";
require("dotenv").config();
window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
//import LandingContainer from './Components/LandPage';

class App extends Component {
    render() {
        return (
            <Router>
                <Fragment>
                    <CssBaseline/>
                    <Header/>
                    <LandingContainer/>
                    <Footer/>
                </Fragment>
            </Router>
        );
    }
}

export default App;
